<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <!-- Add Holiday -->
  <div class="modal fade custom-modal" id="add-holiday">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Add Holiday</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body pt-0">
          <form action="#">
            <div class="wallet-add">
              <div class="form-group">
                <label class="col-form-label">Holiday Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Holiday Name"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">From</label>
                <div class="form-icon">
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="cus-icon">
                    <i class="feather-calendar"></i>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">To</label>
                <div class="form-icon">
                  <date-picker
                    v-model="startdateOne"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="cus-icon">
                    <i class="feather-calendar"></i>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Description</label>
                <textarea class="form-control" rows="4"></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end align-items-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Holiday -->

  <!-- Add Leave -->
  <div class="modal fade custom-modal" id="add-leave">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Add Leave</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body pt-0">
          <form action="#">
            <div class="wallet-add">
              <div class="form-group">
                <label class="col-form-label">From</label>
                <div class="form-icon">
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="cus-icon">
                    <i class="feather-calendar"></i>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">To</label>
                <div class="form-icon">
                  <date-picker
                    v-model="startdateOne"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="cus-icon">
                    <i class="feather-calendar"></i>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Reason</label>
                <textarea class="form-control" rows="3"></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end align-items-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Leave -->

  <!-- Alert Message -->
  <div class="modal fade custom-modal" id="alertmsg">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Add Message</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body pt-0">
          <form action="#">
            <div class="msg-alert">
              <p>If You Take Your Appointment Automatically Cancelled.</p>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end align-items-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Alert Message -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->

  <!-- /Page Wrapper -->
</template>
